import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { RouteErrorBoundary } from "../../../utils/RouteErrorBoundary.js";
import { RouteItemContext } from "../context.js";
import { useRouter } from "../hooks/useRouter.js";
import { useRouterState } from "../hooks/useRouterState.js";
export const AppRenderer = memo(() => {
    const { appData, appComponent: AppComponent } = useRouter().loader;
    const { activeRoute } = useRouterState();
    const app = useMemo(() => {
        return (_jsx(AppComponent, { ...appData, children: _jsx(MainRoute, {}) }));
    }, [AppComponent, appData]);
    return _jsx(RouteItemContext.Provider, { value: activeRoute, children: app });
});
export function MainRoute() {
    const activeRoute = useRouterState((s) => s.activeRoute);
    return _jsx(RouteDisplay, { route: activeRoute });
}
export function RouteDisplay(props) {
    const Component = props.route.component;
    if (!Component) {
        console.error("No component for route");
    }
    const router = useRouter();
    return useMemo(() => {
        let child = !!Component && _jsx(Component, { ...props.route.props });
        if (router.isAI) {
            child = _jsx("div", { id: "ai-page-contents", children: child });
        }
        return (_jsx(RouteErrorBoundary, { route: props.route, onError: (error, errorInfo) => {
                if (env.client) {
                    if (error.message.includes("Failed to fetch dynamically imported module")) {
                        router.emitEvent({
                            type: "error:component-load-failed",
                            error,
                        });
                    }
                }
            }, children: _jsx(RouteItemContext.Provider, { value: props.route, children: child }) }));
    }, [Component, props.route, props.route]);
}
RouteDisplay.displayName = "RouteDisplay";
